import React from 'react';

const ModalConfirm = ({ show, message, onConfirm, onCancel }) => {
    if (!show) {
        return null; // Si el modal no debe mostrarse, no renderizar nada.
    }

    return (
        <div
            className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
            style={{ backdropFilter: 'blur(5px)' }} // Aplica un desenfoque en el fondo
        >
            <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
                <h2 className="text-xl font-semibold mb-4">Confirmación</h2>
                <p className="mb-6">{message}</p>
                <div className="flex justify-end">
                    <button
                        onClick={onCancel}
                        className="bg-gray-700 text-white rounded px-4 py-2 mr-2"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className="bg-red-500 text-white rounded px-4 py-2"
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalConfirm;
